import ROUTES from '@/shared/constants/routes';

const withSlug = (path: string, slug: string) => path.replace(':slug', slug);

export const qrPath = {
  page: (slug: string) => withSlug(ROUTES.QR_PUBLIC, slug),
  request: (publicId: string) => ROUTES.QR_PUBLIC_REQUEST.replace(':publicId', publicId),
};
